<script>
import { GetItemDetailList } from '@/api/general-api'
export default {
  name: 'UserInvoiceEdit',
  data() {
    // 自定义手机号规则
    const RegTel = (rule, value, callback) => {
      if (!value || /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/.test(value)) {
        return callback()
      }
      callback(new Error('请输入正确的电话格式'))
    }

    // --银行卡号有效验证
    const validateBankAccount = (rule, value, callback) => {
      if (!value || /^([1-9]{1})(\d{15}|\d{16}|\d{18})$/.test(value)) return callback()
      callback(new Error('请输入正确的银行卡号'))
    }
    // --纳税人识别号有效验证
    const validateCertificate = (rule, value, callback) => {
      if (!value || /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(value)) return callback()
      callback(new Error('请输入正确的纳税人识别号'))
    }
    // --发票抬头有效验证
    const validateCompanyName = (rule, value, callback) => {
      if (/^[a-zA-Z\u4e00-\u9fa5\s（）()<>《》\(\)\-]{1,50}$/.test(value) && value != null) return callback()
      callback(new Error('请输入有效发票抬头'))
    }

    return {
      visible: false,
      width: '400px',
      invoiceType: [],
      BankList: [],
      formData: {
        ID: null,
        InvoiceType: '普通发票',
        CompanyName: null,
        Certificate: null,
        RegAdd: null,
        DepositBank: null,
        BankAccount: null,
        RegLinker: null,
        RegTel: null,
      },
      formRules: {
        InvoiceType: [{ required: true, message: '发票类型是必须的', trigger: 'change' }],
        CompanyName: [{ required: true, trigger: 'blur', validator: validateCompanyName }],
        RegTel: [{ required: true,trigger: 'blur' }],
        BankAccount: [{ validator: validateBankAccount, trigger: 'blur' }],
        Certificate: [{ validator: validateCertificate, trigger: 'blur' }],
      }
    }
  },
  render(h) {
    const { visible, width } = this;
    if (!visible) {
      return null;
    }
    return (
      <div id="order-files-box">
        <el-dialog
          title="开票信息编辑"
          class="order-files-dialog"
          ref="orderFilesDialog"
          visible={visible}
          show-close
          close-on-click-modal={false}
          width={width}
          before-close={this.onClose}
          destroy-on-close
          v-el-drag-dialog
        >
          {this.renderForm()}
          <span slot="footer" class="dialog-footer">
            <el-button
              size="small"
              icon="el-icon-check"
              type="primary"
              on-click={this.onSubmit}
            >提 交</el-button>
          </span>
        </el-dialog>
      </div>
    )
  },
  methods: {
    renderForm() {
      const { formData, formRules, invoiceType, BankList } = this
      const formProps = {
        model: formData
      }
      return (
        <el-form ref="form" inline rules={formRules} props={formProps}>
          <el-row type="flex" justify="flex-start" align="flex-start" style="flex-wrap:wrap;">
            <el-col span={24}>
              {this.renderFormItem('发票类型', 'InvoiceType', true, invoiceType)}
            </el-col>
            <el-col span={24}>
              {this.renderFormItem('发票抬头', 'CompanyName', true)}
            </el-col>
            <el-col span={24}>
              {this.renderFormItem('纳税人识别号', 'Certificate', true)}
            </el-col>
            <el-col span={24}>
              {this.renderFormItem('注册联系人', 'RegLinker')}
            </el-col>
            <el-col span={24}>
              {this.renderFormItem('注册电话号码', 'RegTel', true)}
            </el-col>
            <el-col span={24}>
              {this.renderFormItem('注册地址', 'RegAdd')}
            </el-col>
            <el-col span={24}>
              {this.renderFormItem('开户银行', 'DepositBank', false, BankList)}
            </el-col>
            <el-col span={24}>
              {this.renderFormItem('银行账号', 'BankAccount', true)}
            </el-col>
          </el-row>
        </el-form>
      )
    },
    renderFormItem(label, prop, validate, dataSource) {
      if (dataSource) {
        return this.renderSingleSelect(label, prop, validate, dataSource)
      }
      return this.renderInput(label, prop, validate)
    },
    renderSingleSelect(label, prop, validate, dataSource) {
      console.log('- renderSingleSelect -', dataSource)
      const { formData } = this
      const onChange = val => {
        formData[prop] = val
      }
      return (
        <el-form-item label={label} prop={validate ? prop : null} style="position: relative" class="full-width">
          <el-select
            on-change={onChange}
            style="width:100%;"
            size="small"
            allow-create={prop==='DepositBank'?true:false}
            value={formData[prop]}
            placeholder="请选择"
            multiple={false}
            clearable={false}
            filterable
          >
            {
              dataSource.map(item => {
                return (<el-option
                  label={item.label}
                  value={item.value}
                />
                )
              })
            }
          </el-select>
        </el-form-item>
      )
    },
    renderInput(label, prop, validate) {
      const onChange = val => {
        this.formData[prop] = val ? val.trim() : ''
      }
      const onInput = val => {
        this.formData[prop] = val
      }
      return (
        <el-form-item label={label} prop={validate ? prop : null} class="full-width">
          <el-input
            size="small"
            clearable
            value={this.formData[prop]}
            on-change={onChange}
            on-input={onInput}
          ></el-input>
        </el-form-item>
      )
    },
    Options(obj) {
      if (obj) {
        this.formData = { ...obj }
      }

    },
    Open(onOkCallback) {
      GetItemDetailList({ ItemCode: 'BankList' }).then(res => {
        if (res.success) {
          this.BankList = res.data.map(x => ({
            value: x.ItemValue,
            label: x.ItemName
          }))
        }
        GetItemDetailList({ ItemCode: 'invoiceType' }).then(res => {
          if (res.success) {
            this.invoiceType = res.data.map(x => ({
              value: x.ItemValue,
              label: x.ItemName
            }))
          }
          this.visible = true;
          this.onOkCallback = onOkCallback
        })
      })

    },
    onOK() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        if (typeof this.onOkCallback === 'function') {
          this.onOkCallback({ ...this.formData }, () => this.visible = false)
        }
      })

    },
    onSubmit() {
      this.onOK()
    },
    onClose() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.enterprise-form {
  width: 100%;
}
.order-files-dialog {
  height: 100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 2501 !important;

  .el-dialog {
    max-height: 95% !important;
    min-height: 300px !important;
    max-width: 95% !important;
    min-width: 540px !important;
    display: flex;
    flex-direction: column;
    position: relative !important;
    margin: 0 auto !important;

    .el-dialog__body {
      padding: 15px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
      flex: 1;
      height: 99% !important;
      overflow-y: scroll;
      position: relative !important;
    }
  }
}
</style>